// extracted by mini-css-extract-plugin
export default {"mCard":"xA-z","image":"yA-z","imageNoBackground":"zA-z","imageHasCategory":"AA-z","fullWidth":"BA-z"};